<template>
  <div>
    <component :is="componentInstance" :key="company.id" :profilfarbe="ProfilFarbe" :profildark="ProfilDark" :profilfarbenstyle="ProfilFarbenStyle"/>

  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    company: { type: Object }
  },
  computed: {

    // Webpack fail
    componentInstance () {
      const id = this.company.id
      // const Foo = () => import(`~/pages/companies/premium/${id}`)
      const Foo = () => import(/* webpackChunkName: "prem-profile" */ `~/pages/companies/premium/${id}`)
      try {
        return Foo
      } catch (e) {
        console.log('kein prem profil vorhanden')
      }
    },
    ProfilDark: function () {
      var dark = true
      if (this.company) {
        if (this.company.profildark) {
          if (this.company.profildark === 1) {
            dark = false
          }
        }
      }
      return dark
    },
    ProfilFarbe: function () {
      var farbe
      if (this.company) {
        if (this.company.profilfarbe) {
          farbe = this.company.profilfarbe
        } else {
          farbe = '#e50a46'
        }
      } else {
        farbe = '#e50a46'
      }
      return farbe
    },
    ProfilFarbenStyle: function () {
      var farbe
      if (this.company) {
        if (this.company.profilfarbe) {
          farbe = this.company.profilfarbe
        }
      } else {
        farbe = '#212121'
      }
      const styleObject = 'color: ' + farbe + ';'
      return styleObject
    }
  }
}
</script>
